<template>
  <div></div>
</template>

<script>
export default {
  name: "Empty.vue",
};
</script>

<style scoped></style>
